<template>
  <div class="item-container">
    <div
      :id="`itemexpander-${item.jsonid}`"
      class="item-main"
      :class="{ 'item-active': dropdown }"
      @click="toggleExpand"
    >
      <div class="item-title">
        <i
          v-if="!motorhome"
          class="icon-car_hire vtd-icon-4 glyph-lg mr-3 vtd-align-middle"
        />
        <i
          v-if="motorhome"
          class="icon-motorhome vtd-icon-4 glyph-lg mr-3 vtd-align-middle"
        />
        <span>{{ item.vehicletype }}</span>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6 v-if="!motorhome">
          {{ item.cardesc }}
        </h6>
        <h6 v-if="motorhome">
          {{ item.carrate }}
        </h6>
        <p>for {{ item.duration }}</p>
      </div>
      <!-- This will be hidden on mobile devices -->
      <div class="item-main-desktop">
        <h6>
          Pick up: {{ item.pickupcity }}
          <span v-if="!motorhome"> - {{ item.pickuptime }}</span>
        </h6>
        <!-- <p v-if="fil === 'M'">
          Drop off: {{ item.dropoffcity }}
          <span v-if="!motorhome"> - {{ item.enddate }}</span>
        </p> -->
      </div>
      <div class="toggle">
        <span v-if="!dropdown">+</span>
        <span v-else>-</span>
      </div>
    </div>
    <div
      v-if="dropdown"
      class="item-dropdown"
    >
      <div class="item-dropdown-main">
        <ul>
          <li
            v-if="item.pickupcity"
            class="mobile-dropdown-item"
          >
            <h4>Pick up</h4>
            <p>{{ item.pickupcity }} - {{ item.pickuptime }}</p>
          </li>
          <li
            v-if="item.dropoffcity"
            class="mobile-dropdown-item"
          >
            <h4>Drop off</h4>
            <p>{{ item.dropoffcity }} - {{ item.enddate }}</p>
          </li>
          <li
            v-for="expanderItem in item.expanderItems"
            :key="expanderItem.title"
          >
            <h4>{{ expanderItem.title }}</h4>
            <p style="padding-top: 12px">
              {{ expanderItem.notes }}
            </p>
          </li>
        </ul>
        <div class="extra-info">
          <video
            v-if="motorhome && item.suppliername === 'MAUI'"
            class="video-js"
            muted="true"
            controls="true"
            poster="https://cdn.trailfinders.com/khntpwtkr0_maui.jpg"
          >
            <source
              src="https://vz-0c5f29ad-8d4.b-cdn.net/5033b551-64b3-4301-b75e-3caf2798636b/play_720p.mp4"
              type="video/mp4"
            >
          </video>
          <div class="thumbnail-container" v-if="motorhome && item.suppliername === 'APOLLO'">
            <span><!---->
              <img src="https://cdn.trailfinders.com/apollo.jpg?width=500" class="lightbox-thumbnail">
            </span>
          </div>
          <div class="thumbnail-container" v-if="motorhome && item.suppliername === 'MIGHTY'">
            <span><!---->
              <img src="https://cdn.trailfinders.com/mighty.jpg?width=500" class="lightbox-thumbnail">
            </span>
          </div>
          <ExtraInfoButtons
            v-if="!motorhome"
            :item="item"
            itemtype="carhire"
          />
          <ExtraInfoButtons
            v-if="motorhome"
            :item="item"
            :vehiclefile="vehiclefile"
            :vehiclefiletitle="vehiclefiletitle"
            :depotfile="depotfile"
            :depotfiletitle="depotfiletitle"
            itemtype="motorhome"
          />
        </div>
      </div>
      <div
        v-if="item.fnotes[0]"
        class="extra-info-notes"
      >
        Notes
        <ul>
          <li
            v-for="(note, index) in item.fnotes"
            :key="index"
          >
            {{ note }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import ExtraInfoButtons from "@/partials/extra-info-buttons";
import { mapGetters } from "vuex";

export default {
  components: {
    ExtraInfoButtons,
  },
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
  mounted() {
    this.$root.$on("collapseall", () => {
      this.collapseAll();
    });
    this.$root.$on("expandall", () => {
      this.expandAll();
    });
  },
  computed: {
    ...mapGetters({ fil: "booking/getFil" }),
    motorhome() {
      return this.item.vehicletype
        ? this.item.vehicletype === "MOTORHOME RENTAL"
        : null;
    },
    depotfile() {
      return this.item.depotmap
        ? `/tourdoc/vehicles/${this.item.depotmap}`
        : null;
    },
    depotfiletitle() {
      let _tmp = "Depot";
      if (this.item.depotmap.indexOf("TRF") === 0) {
        _tmp = "Transfer";
      }
      return this.item.depotmap
        ? `${this.item.vehicletype} ${_tmp} Information`
        : null;
    },
    vehiclefile() {
      return this.item.depotmap ? `${this.item.holesswithdir}` : null;
    },
    vehiclefiletitle() {
      return this.item.depotmap
        ? `${this.item.vehicletype} Holiday Essentials`
        : null;
    },
  },
  data() {
    return {
      dropdown: true,
    };
  },
  methods: {
    toggleExpand() {
      this.dropdown = !this.dropdown;
    },
    collapseAll() {
      this.dropdown = false;
    },
    expandAll() {
      this.dropdown = true;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./styles.scss";
</style>
